import React from 'react';
import Base from './Base';
import Button from '../Button/Button';
import Icon from '../../foundations/Icons';

export type PromptProps = {
  onRequestClose?: () => void;
  onAccept?: (...args) => void;
  isOpen?: boolean;
  title: React.ReactNode;
  loading?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  cancelActionLabel?: string;
  hasFooter?: boolean;
  actionLabel?: string;
  actionType?: 'button' | 'submit';
  subtitle?: string;
  footer?: JSX.Element;
  displayCloseButton?: boolean;
};

export const Prompt = ({
  isOpen = false,
  displayCloseButton = true,
  hasFooter = true,
  title = '',
  subtitle = '',
  children,
  footer = undefined,
  cancelActionLabel = 'Cancel',
  loading = false,
  disabled = false,
  actionLabel = '',
  actionType = 'button',
  onAccept = undefined,
  onRequestClose = () => {},
}: PromptProps) => (
  <Base isOpen={isOpen} onRequestClose={onRequestClose}>
    <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
      <div className="px-s pb-s pt-m bg-card sm:p-s">
        <div className="flex justify-between">
          <div className="pb-m">
            {Boolean(title) && (
              <h3 className="font-heading text-h3 text-strong">{title}</h3>
            )}
            {subtitle && (
              <h4 className="font-heading text-h4 text-subtle">{subtitle}</h4>
            )}
          </div>

          {displayCloseButton && (
            <div className="hidden pt-xxxs sm:block">
              <div
                onClick={onRequestClose}
                onKeyPress={onRequestClose}
                aria-label="Close modal"
                role="button"
                tabIndex={0}
              >
                <Icon name="lClose" />
              </div>
            </div>
          )}
        </div>

        <div>{children}</div>
      </div>
      {hasFooter && (
        <>
          {footer || (
            <div className="flex w-full justify-end px-s py-xs sm:px-l mobile:flex-row-reverse">
              <Button
                type="button"
                variant="tertiary"
                disabled={loading}
                onClick={onRequestClose}
              >
                {cancelActionLabel}
              </Button>

              <Button
                type={actionType}
                variant="primary"
                onClick={() => {
                  if (onAccept && !loading) {
                    onAccept();
                  }
                }}
                disabled={disabled ?? false}
                loading={loading}
              >
                {actionLabel}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  </Base>
);

export default Prompt;
